export default __webpack_public_path__ + "static/media/path.2e934e1c.svg";